import axios from "axios";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { HiX } from "react-icons/hi";

function AddCategory({ id, onClose, getAllCategories }) {
  const [loading, setLoading] = useState(false);

  //Initializing react-hook-form
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    setLoading(true);
    const finalData = {
      ...data,
      userId: id,
    };
    console.log("Final Data: ", finalData);
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/category/create-category`,
      headers: {},
      data: finalData,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of onSubmit: ", response.data);
        setLoading(false);
        onClose();
        getAllCategories();
        toast.success(response.data.message);
      })
      .catch((error) => {
        console.log("Error in adding category: ", error);
        toast.error("Error in adding new category");
        setLoading(false);
      });
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm  backdrop-brightness-75"
      onClick={onClose}
    >
      <div
        className="relative max-h-[90%] w-[95%] max-w-lg overflow-y-auto rounded-lg bg-white p-4 shadow-lg md:p-8 lg:h-auto lg:px-6 lg:py-8"
        onClick={(e) => e.stopPropagation()}
      >
        <HiX
          className="absolute right-4 top-4 cursor-pointer text-primary hover:text-red-500"
          size={20}
          onClick={onClose}
        />
        <h1 className="text-center text-3xl font-bold tracking-wide text-primary">
          Add Category
        </h1>

        {/* Input Fields  */}
        <form
          className="my-4 grid grid-cols-1 gap-4 "
          onSubmit={handleSubmit(onSubmit)}
        >
          {/* Category Name  */}
          <div className="flex flex-col gap-2 md:col-span-1">
            <label
              htmlFor="name"
              className="text-sm font-semibold tracking-wide text-primaryText"
            >
              Category Name <span className="text-red-500">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter Category Name"
              {...register("name", { required: "Category Name is required" })}
              className={`rounded border bg-transparent px-4 py-2 outline-none focus:ring-1 focus:ring-primary ${
                errors.name ? "border-red-500" : "border-gray-800"
              }}`}
            />

            {errors.name && (
              <span className="text-sm text-red-500">
                {errors.name.message}
              </span>
            )}
          </div>

          {/* Category Description  */}
          <div className="flex flex-col gap-2 md:col-span-2">
            <label
              htmlFor="categoryDescription"
              className="text-sm font-semibold tracking-wide text-primaryText"
            >
              Category Description
            </label>

            <textarea
              type="text"
              placeholder="Enter Category Description"
              {...register("categoryDescription")}
              className={`resize-none rounded border bg-transparent px-4 py-2 outline-none focus:ring-1 focus:ring-primary ${
                errors.categoryDescription
                  ? "border-red-500"
                  : "border-gray-800"
              }}`}
            />

            {errors.categoryDescription && (
              <span className="text-sm text-red-500">
                {errors.categoryDescription.message}
              </span>
            )}
          </div>

          {/* Buttons  */}
          <div className="flex gap-4 md:col-span-2">
            <button
              type="button"
              className="mt-4 w-1/2 rounded bg-gray-200 py-2 font-semibold tracking-wide text-gray-800 shadow-md hover:bg-gray-400 md:w-full"
              onClick={() => reset({ name: "", categoryDescription: "" })}
            >
              Clear
            </button>

            <button
              type="submit"
              className=" mt-4 flex w-1/2 justify-center  rounded bg-primary py-2 font-semibold tracking-wide text-white shadow-md hover:bg-hoverPrimary   md:w-full"
            >
              {loading ? <div className="loaderButton"></div> : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddCategory;
